var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coach-detail-review-summary"},[_c('span',[_vm._v(_vm._s(_vm.formatReviewRateAverage))]),_c('rating-star',{attrs:{"rating":_vm.coach.reviewRateAverage,"size":28}}),_c('span',[_vm._v(_vm._s(`${_vm.numberFormat(_vm.coach.reviewCount)}件の評価`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }